import {TranslateLoader} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {Languages} from './languages';

export class FileLoader implements TranslateLoader {

    constructor(private readonly languages: Array<Languages>) {
    }

    getTranslation(langId: string): Observable<unknown> {
        const combinedLanguageKeys = {};
        const filteredLanguages = this.languages.filter(value => !!value[langId]);
        filteredLanguages.forEach(language => {
            Object.assign(combinedLanguageKeys, language[langId]);
        });
        return of(combinedLanguageKeys);
    }
}
